<script>
import forminput from "../formcomponet/forminput.vue";
import formcheckbox from "../formcomponet/formcheckbox.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznfirma from "@/models/mznfirma";
export default {
  mixins: [apibtoast, apigeneric, mznfirma],
  page: {
    title: "Giriş",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    forminput,
    formtextarea,
    Treeselect,
    formcheckbox
  },
  data() {
    return {
      FormData: {},
      ilkodu: ""
    };
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.Post(this.$config.API_URL_2 + "mznfirma", this.FormData);
        document.getElementById("delay").disabled = true;
        this.$refs.form.reset();
        setTimeout(function() {
        document.getElementById("delay").disabled = false;
    }, 3000);
      }
    },
    ilce_yukle(ustid) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      (this.FormDataType.Adresilceid.ComboDataArray = []),
        this.ActionsGet({ Service: "OIlIlce/" + ustid, Page: Page }).then(
          (res) => {
            this.ilkodu = res.Data.Kod;

            this.ActionsFilterGet({
              Service: "OIlIlce",
              Page: Page,
              Filter: "&Ustid=" + this.ilkodu,
            }).then((res) => {
              for (var i = 0; i < res.Data.length; i++) {
                this.FormDataType.Adresilceid.ComboDataArray.push({
                  id: res.Data[i].Id,
                  label: res.Data[i].Value,
                });
              }
            });
          }
        );
    },

    Get() {
      this.FormData = this.mznfirmaData;
    },
  },
};
</script>

<template>
  <div class="login-form mt-5">
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <Form @submit.prevent="onSubmit" ref="form">
          <div class="row">
            <div class="col-md-6 mb-3">
              <forminput
                :FormDataType="FormDataType.Firmaadi"
                :Value="FormData.Firmaadi"
                :v="$v.FormData.Firmaadi"
                @input="FormData.Firmaadi = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <forminput
                :FormDataType="FormDataType.Telefon"
                :Value="FormData.Telefon"
                :v="$v.FormData.Telefon"
                @input="FormData.Telefon = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <forminput
                :FormDataType="FormDataType.Fax"
                :Value="FormData.Fax"
                :v="$v.FormData.Fax"
                @input="FormData.Fax = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <forminput
                :FormDataType="FormDataType.Email"
                :Value="FormData.Email"
                :v="$v.FormData.Email"
                @input="FormData.Email = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <forminput
                :FormDataType="FormDataType.Vergino"
                :Value="FormData.Vergino"
                :v="$v.FormData.Vergino"
                @input="FormData.Vergino = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <forminput
                :FormDataType="FormDataType.Vergidairesi"
                :Value="FormData.Vergidairesi"
                :v="$v.FormData.Vergidairesi"
                @input="FormData.Vergidairesi = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <formtextarea
                :FormDataType="FormDataType.Firmaadresi"
                :Value="FormData.Firmaadresi"
                :v="$v.FormData.Firmaadresi"
                @input="FormData.Firmaadresi = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <formtextarea
                :FormDataType="FormDataType.Aciklama"
                :Value="FormData.Aciklama"
                :v="$v.FormData.Aciklama"
                @input="FormData.Aciklama = $event"
              />
            </div>
            <div class="col-md-6 mb-3">
              <b-form-group
                id="example text"
                :label="FormDataType.Adresilid.FieldTitle"
                label-for="text"
              >
                <treeselect
                  :multiple="false"
                  :options="FormDataType.Adresilid.ComboDataArray"
                  :placeholder="$t('OrtakKullanim.seciniz')"
                  @input="ilce_yukle(FormData.Adresilid)"
                  v-model="FormData.Adresilid"
                  :class="{ 'is-invalid': $v.FormData.Adresilid.$error }"
                />
                <treeselect-value :value="FormData.Adresilid" />

                <div
                  v-if="$v.FormData.Adresilid.$error"
                  class="invalid-feedback"
                >
                  <span v-if="$v.FormData.Adresilid.required == false">{{
                    $t("ValidationMessage.required")
                  }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-6 mb-3">
              <b-form-group
                id="example text"
                :label="FormDataType.Adresilceid.FieldTitle"
                label-for="text"
              >
                <treeselect
                  :multiple="false"
                  :options="FormDataType.Adresilceid.ComboDataArray"
                  :placeholder="$t('OrtakKullanim.seciniz')"
                  v-model="FormData.Adresilceid"
                  :class="{ 'is-invalid': $v.FormData.Adresilceid.$error }"
                />
                <treeselect-value :value="FormData.Adresilceid" />

                <div
                  v-if="$v.FormData.Adresilceid.$error"
                  class="invalid-feedback"
                >
                  <span v-if="$v.FormData.Adresilceid.required == false">{{
                    $t("ValidationMessage.required")
                  }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-6 mb-3">
              <i class="fas fa-eye" v-b-modal.kvkkmetni2  ></i>
              <formcheckbox
                :FormDataType="FormDataType.Kvkk"
                :Value="FormData.Kvkk"
                :v="$v.FormData.Kvkk"
                @input="FormData.Kvkk = $event"
              />
            </div>
          </div>

          <button class="btn btn-primary" type="submit" id="delay">
            {{ $t("mznfirma.AddEdit.Button") }}
          </button>
        </Form>
      </div>
      <div class="col-md-1"></div>
    </div>
  </div>
</template>
 